import type { PanelLayout } from '@/models/settings';
import type { GridLayout } from '../ViewerContext';
import { toGridLayout } from './viewerUrlState';

// Smallest first, taller than wide (the viewer is tall), so a set of clips
// gets the tightest grid.
const FIT_LAYOUTS: PanelLayout[] = [
  '1x1',
  '2x1',
  '3x1',
  '2x2',
  '3x2',
  '4x2',
  '3x3',
  '4x3',
  '4x4',
];

/** The smallest grid that holds `count` clips; 4x4 when there are more. */
export function gridLayoutForClipCount(count: number): GridLayout {
  return (
    FIT_LAYOUTS.map(toGridLayout).find(
      ({ rows, cols }) => rows * cols >= count
    ) ?? toGridLayout('4x4')
  );
}
